/**
 * Which build of the field app is calling — so the API can tell an old install
 * from a new one.
 *
 * WHY A HEADER ON EVERY REQUEST. The login body has always carried
 * `device.appVersion`, but only at login, and a store update keeps the session:
 * a salesperson who updates from 1.0.4 is never asked to sign in again, so a
 * version captured there would describe the build they had weeks ago. The
 * header is sent by whatever build is running NOW, including on a replayed
 * request from the upload queue.
 *
 * ABSENT MEANS OLD. Builds up to 1.0.4 never send it, and that is the point:
 * a rule that only a newer build can satisfy — the questionnaire gate at
 * check-out — applies only when the header says the build is new enough, so
 * phones that have not updated keep working exactly as before.
 */
export const APP_VERSION_HEADER = 'x-app-version';
/**
 * The first field-app build with a questionnaire screen. Older builds cannot
 * fill one, so the "questionnaire required at check-out" toggle must not apply
 * to them — it would trap them inside a visit with no way out.
 */
export const QUESTIONNAIRE_MIN_APP_VERSION = '1.0.5';
/** `MAJOR.MINOR.PATCH` as numbers, or null for anything else. */
function parseAppVersion(value) {
    const match = /^(\d+)\.(\d+)\.(\d+)$/.exec(value.trim());
    if (!match)
        return null;
    return [Number(match[1]), Number(match[2]), Number(match[3])];
}
/**
 * Whether `version` is at least `minimum`.
 *
 * A missing or unparseable version answers FALSE — the header is absent on
 * every build that predates it, and an unreadable one is treated the same way
 * rather than guessed at.
 */
export function isAppVersionAtLeast(version, minimum) {
    if (!version)
        return false;
    const actual = parseAppVersion(version);
    const required = parseAppVersion(minimum);
    if (!actual || !required)
        return false;
    for (let i = 0; i < 3; i += 1) {
        const a = actual[i];
        const r = required[i];
        if (a !== r)
            return a > r;
    }
    return true;
}
//# sourceMappingURL=client-version.js.map